import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ThemeApi } from './model/theme.api.model';
import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';
import { NeptuneApi } from '../genericApi/neptune.api';
import { MultiBaseAbstractApi } from '../genericApi/multi-base-abstract.api';


@Injectable()
export class ThemeApiService extends MultiBaseAbstractApi<ThemeApi, ThemeApi> {

    constructor(private neptuneApi: NeptuneApi) {
        super();
    }

    /**
    * Gets all social themes from the current account
    */
    getList(): Observable<ThemeApi[]> {
        const slug = '/themes';

        return this.neptuneApi.api(
            slug,
            null,
            HttpVerbsEnum.GET
        );
    }


    getById(id: number | string): Observable<ThemeApi> {
        const slug = `/themes/${id}`;

        return this.neptuneApi.api(
            slug,
            null,
            HttpVerbsEnum.GET
        );
    }


    create(theme: ThemeApi): Observable<number> {
        const slug = '/themes';

        return this.neptuneApi.api(
            slug,
            theme,
            HttpVerbsEnum.POST
        );
    }

    /** @TODO - change endpoint to return id */
    update(theme: ThemeApi): Observable<number> {
        const slug = `/themes/${theme.id}`;

        return this.neptuneApi.api(
            slug,
            theme,
            HttpVerbsEnum.PUT
        ).pipe(map(() => theme.id));
    }

    deleteById(id: number): Observable<number> {
        const slug = `/themes/${id}`;

        return this.neptuneApi.api(
            slug,
            null,
            HttpVerbsEnum.DELETE
        );
    }
}
